import { NAME } from './constants';

export const LOAD_FLIGHT = `${NAME}/LOAD_FLIGHT`;
export const LOAD_SUCCESS = `${NAME}/LOAD_SUCCESS`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
